import apiClient, {timeouts} from 'shared/services/apiClient';
import {CompareDataframesResp, GetUploadedFilesMetaResp} from "../types";
import {endpoints} from "shared/services/endpoints";
import {fileService} from "shared/services/fileService";
import {SuccessResponse} from "shared/types/common";

export const excelDiffService = {
    compareExcels: async (cat_num: number, dt1?: number, dt2?: number) => {
        return apiClient
            .post<CompareDataframesResp>(endpoints.excelDiff.compare, {cat_num, dt1, dt2}, {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as CompareDataframesResp)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as CompareDataframesResp;
            }
        );
    },

    getCompareExcelsStatus: async (tracking_tag: string) => {
        return apiClient
            .get<SuccessResponse>(endpoints.excelDiff.status(tracking_tag), {timeout: timeouts.simpleOperationsTimeout})
            .then(r => r.data as SuccessResponse)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as SuccessResponse;
            }
        );
    },

    fetchExcelsComparisonResults: async (tracking_tag: string) => {
        return apiClient
            .get<CompareDataframesResp>(endpoints.excelDiff.results(tracking_tag), {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as CompareDataframesResp)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as CompareDataframesResp;
            }
        );
    },

    getUploadedCustomCsvMeta: async () => {
        return apiClient
            .get<GetUploadedFilesMetaResp>(endpoints.customComparison.meta, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as GetUploadedFilesMetaResp)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as GetUploadedFilesMetaResp;
            }
        );
    },

    uploadCustomCsv: async (position: number, file: File) => {
        const endpoint_url = endpoints.customComparison.uploadAt(position)
        return await fileService.uploadCompressedFile(endpoint_url, file);
    },

    compareCustom: async () => {
        return apiClient
            .post<CompareDataframesResp>(endpoints.customComparison.compare, {}, {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as CompareDataframesResp)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as CompareDataframesResp;
            }
        );
    },
};
